module.exports = __webpack_public_path__ + "media/typing-advanced-missed.f219695a.mp3";